import { render, staticRenderFns } from "./JobsSidebarList.vue?vue&type=template&id=53265516&"
import script from "./JobsSidebarList.vue?vue&type=script&lang=ts&"
export * from "./JobsSidebarList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JobListItemSkeleton: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/jobs/lists/JobListItemSkeleton.vue').default,BursaryListItem: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/bursaries/BursaryListItem.vue').default,JobsListItem: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/jobs/lists/JobsListItem.vue').default,EmptyState: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/EmptyState.vue').default,ButtonSecondary: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/buttons/ButtonSecondary.vue').default})
